import { useState, useEffect, useCallback } from "react";
import { MessageCircle } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { useNavigate } from "react-router-dom";

export const MessageBadge = () => {
  const { api } = useAuth();
  const navigate = useNavigate();
  const [unread, setUnread] = useState(0);

  const fetchUnread = useCallback(async () => {
    try {
      const res = await api.get("/messages/unread-total");
      setUnread(res.data.count);
    } catch (err) { console.error(err); }
  }, [api]);

  useEffect(() => {
    fetchUnread();
    const interval = setInterval(fetchUnread, 30000);
    return () => clearInterval(interval);
  }, [fetchUnread]);

  return (
    <button
      onClick={() => navigate("/messages")}
      className="p-2 rounded-full hover:bg-foreground/5 text-muted-foreground relative"
      data-testid="message-badge"
    >
      <MessageCircle className="w-4 h-4" />
      {unread > 0 && (
        <span className="absolute -top-0.5 -right-0.5 bg-[#FF8FA3] text-white text-[10px] font-bold w-4 h-4 rounded-full flex items-center justify-center">
          {unread > 9 ? "9+" : unread}
        </span>
      )}
    </button>
  );
};
